import React from "react";

// Admin Imports
import Dashboard from "views/console/default";
import TopFarmersView from "views/console/default/top-farmers-view";
import FarmLocationsMap from "views/console/default/farm-locations-map";
import Profile from "views/admin/profile";

// Auth Imports
import SignIn from "views/auth/SignIn";
import AdminSignIn from "views/auth/AdminSignIn";
import Register from "views/auth/Register";
import ScanQR from "views/auth/ScanQR";
import HomeScreen from "views/home/HomeScreen";
import DaDohScreen from "views/home/DaDohScreen";

// Icon Imports
import { HomeOutlined, SettingOutlined, LockOutlined, FolderViewOutlined } from '@ant-design/icons';

import panelRoutes from "views/panel/routes";
import usersRoutes from "views/console/users/routes";
import adminUserRoutes from "views/console/admin-users/routes";
import moduleRoutes from "views/console/modules/routes";
import accessRightsRoutes from "views/console/access-rights/routes";
import parametersRoutes from "views/console/parameters/routes";
import rolesRoutes from "views/console/roles/routes";

import registeredAnimalRoutes from "views/console/registered-animals/routes";
import farmerRoutes from "views/console/farmer-informations/routes";
import ManualRegister from "views/auth/ManualRegister";

const routes = [
  {
    name: "Home",
    layout: "/home",
    path: "/",
    component: <HomeScreen />,
    isMainMenu:false,
  },
  {
    name: "DA - DOH",
    layout: "/home",
    path: "da-doh",
    component: <DaDohScreen />,
    isMainMenu:false,
  },
  {
    name: "Scan QR",
    layout: "/auth",
    path: "home",
    component: <ScanQR />,
    isMainMenu:false,
  },
  {
    name: "Register",
    layout: "/auth",
    path: "register",
    component: <Register />,
    isMainMenu:false,
  },
  {
    name: "Manual Register",
    layout: "/auth",
    path: "manual-register",
    component: <ManualRegister />,
    isMainMenu:false,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    component: <SignIn />,
    isMainMenu:false,
  },
  {
    name: "Admin Sign In",
    layout: "/auth",
    path: "base/sign-in",
    component: <AdminSignIn />,
    isMainMenu:false,
  },
  {
    name: "Power Admin Sign In",
    layout: "/auth",
    path: "pad/sign-in",
    component: <AdminSignIn />,
    isMainMenu:false,
  },
  {
    name: "Dashboard",
    layout: "/console",
    path: "dashboard",    
    component: <Dashboard />,
    isMainMenu:true,
    icon: <HomeOutlined className="h-6 w-6" />,
    level: 2,
    children: [
      {
        name: "Top Farmers",
        layout: "/console",
        path: "top-farmers",    
        component: <TopFarmersView/>,
        isMainMenu:false,
        level: 2,
      },
        {
        name: "Farm Locations Map",
        layout: "/console",
        path: "farm-locations-map",    
        component: <FarmLocationsMap/>,
        isMainMenu:false,
        level: 2,
      },
    ]
  },
  {
    name: "Manage Records",
    layout: "/console",
    path: "#",    
    component: null,
    isMainMenu:true,
    icon: <FolderViewOutlined className="h-6 w-6"/>,
    level: 2,
    children: [
      ...farmerRoutes,
      ...registeredAnimalRoutes,  
    ]
  },
  {
    name: "User Management",
    layout: "/console",
    path: "#",    
    component: null,
    isMainMenu:true,
    icon: <LockOutlined className="h-6 w-6"/>,
    level: 2,
    children: [
      ...usersRoutes,
      ...adminUserRoutes,
    ]
  },
  {
    name: "Access Management",
    layout: "/console",
    path: "#",    
    component: null,
    isMainMenu:true,
    icon: <LockOutlined className="h-6 w-6"/>,
    level: 1,
    children: [
  
      ...moduleRoutes,
      ...accessRightsRoutes,    
      ...rolesRoutes,
    ]
  },
  {
    name: "Settings",
    layout: "/console",
    path: "#",    
    component: null,
    isMainMenu:true,
    icon: <SettingOutlined className="h-6 w-6"/>,
    level: 1,
    children: [
      ...parametersRoutes,  
    ]
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    component: <Profile />,
    isMainMenu:false,
  },  
  ...panelRoutes,  
];
export default routes;
